import React from 'react'
import { Translate } from 'react-redux-i18n'
import { SCREEN } from '../../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { ChartPriceFDI } from './ChartPriceFDI'
import { YearTab } from './YearTab'

export const ChartIndustryFDI = () => {
  const { formatedUnit } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  return (
    <>
      <div className="w50 h100 flexColumn">
        <div>
          <Translate
            value="industryOverview.macroeconomics.FDI_BY_INDUSTRIES"
            className="fw600"
          />
        </div>
        <YearTab />

        <div className="flex1">
          <ChartPriceFDI />
        </div>

        <div className="dFlex justifyContentEnd">{formatedUnit}</div>
      </div>
      <div
        style={{ position: 'fixed', top: -1000, left: -2000, width: 1600 }}
        id="macroFDIChartIndustryId"
      >
        <ChartPriceFDI yAxisWidth={900} height={600} />
      </div>
    </>
  )
}
